<template>
  <div class="wallet-connect-content">
    <div
      class="wallet-item"
      :class="{
        'circle-item': item.circleLength,
        'active-item':
          (step >= 1 && index === 0) ||
          (step >= 2 && index === 2) ||
          (step >= 3 && index === 4),
        'line-item': (step >= 2 && index === 1) || (step >= 3 && index === 3),
      }"
      v-for="(item, index) in walletStepList"
      :key="index"
      @click="onAddChain(item)"
    >
      <div class="circle-list" v-if="item.circleLength">
        <div class="circle" v-for="(c, j) in item.circleLength" :key="j"></div>
      </div>
      <div class="wallet-left" v-if="item.icon">
        <div class="wallet-logo">
          <img :src="item.icon" alt="" />
          <div class="mask"></div>
        </div>
        <div class="wallet-info" v-if="index > 0">
          {{ item.label }}{{ index === 4 ? ' ' + balance + ' $ZETA' : '' }}
        </div>
        <div class="wallet-info" v-if="index === 0">
          {{
            address
              ? address.slice(0, 10) + '...' + address.slice(-10)
              : item.label
          }}
        </div>
      </div>
      <div class="wallet-right" v-if="item.icon">
        <img class="enter" src="../assets/images/enter.png" alt="" />
        <img class="enter-on" src="../assets/images/enter-on.png" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Web3 from 'web3';
import tp from 'tp-js-sdk';
export default {
  data() {
    return {
      web3: null,
      balance: 0,
    };
  },
  computed: {
    ...mapGetters(['address', 'step', 'isTp']),
    walletStepList() {
      return [
        {
          icon: require(`../assets/images/activity/TokenPocket-logo.png`),
          label: this.$t('connectTPWallet'),
          step: 1,
        },
        {
          circleLength: 7,
        },
        {
          icon: require(`../assets/images/zetachain.png`),
          label: this.$t('addZetaChain'),
          step: 2,
        },
        {
          circleLength: 7,
        },
        {
          icon: require(`../assets/images/zetachain.png`),
          label: this.$t('ZETAAmount'),
          step: 3,
          url: 'https://labs.zetachain.com/get-zeta',
        },
      ];
    },
  },
  watch: {
    // address: {
    //   handler(val) {
    //     if (val) {
    //       this.$store.commit('setStep', 2);
    //       console.log('val', val);
    //     }
    //   },
    //   immediate: false,
    // },
    step(val) {
      if (val === 2) {
        if (window.ethereum) {
          window.ethereum.on('chainChanged', this.checkChain);
        }
      }
      if (val === 3) {
        if (window.ethereum) {
          this.getEthBalance().then((bal) => {
            this.balance = this.truncateDecimals(bal, 2);
          });
        }
      }
    },
  },
  mounted() {
    // console.log('step', this.step);
    if (this.step === 3) {
      this.getEthBalance().then((bal) => {
        this.balance = this.truncateDecimals(bal, 2);
      });
    }
  },
  methods: {
    onAddChain(data) {
      // console.log('onAddChain', data.step);
      // console.log('step', this.step);
      if (data.step === 1 && this.step === 1) {
        this.connectWallet();
      }
      if (data.step === 2 && this.step === 2) {
        this.addZetaChainTestnet()
          .then(() => {
            // console.log('res', window.ethereum.chainId);
            if (window.ethereum && window.ethereum.chainId === '0x1b59') {
              this.getEthBalance().then((bal) => {
                // console.log('bal', bal);
                this.balance = this.truncateDecimals(bal, 2);
              });
              this.$store.commit('setStep', 3);
            }
          })
          .catch((err) => {
            console.log('err', err);
          });
        // if (window.navigator.userAgent.indexOf('TokenPocket') > -1) {
        //   this.$store.commit('setStep', 3);
        //   if (window.ethereum && window.ethereum.chainId === '0x1b59') {
        //     this.getEthBalance().then((bal) => {
        //       console.log('bal', bal);
        //       this.balance = this.truncateDecimals(bal, 2);
        //     });
        //   }
        // }
      }
      if (data.step === 3 && this.step === 3) {
        // this.step = 3;
        this.$store.commit('setStep', 3);
        window.open(data.url, '_self');
      }
    },
    async connectWallet() {
      if (this.isTp) {
        // console.log('loginTP');
        tp.getCurrentWallet().then((res) => {
          if (res.result) {
            // console.log('res', res);
            this.$store.commit('setAddress', res.data.address);
            this.$store.commit('setStep', 2);
          }
        });
      } else {
        // console.log('ethereum', window.ethereum);
        if (window.tokenpocket && window.ethereum.isTokenPocket) {
          let account = await window.ethereum.request({
            method: 'eth_requestAccounts',
          });
          this.$store.commit('setAddress', account[0]);
          this.$store.commit('setStep', 2);
        } else {
          console.log('请先下载');
          this.$emit('walletModal', true);
        }
      }
    },
    async connectWalletByMetaMask() {
      if (window.ethereum) {
        console.log('connectWalletByMetaMask', window.ethereum);
        try {
          let account = await window.ethereum.request({
            method: 'eth_requestAccounts',
          });
          this.$store.commit('setAddress', account[0]);
          this.$store.commit('setStep', 2);
          this.$emit('close');
        } catch (error) {
          console.log(error);
        }
      }
    },
    switchToZetaChainTestnet() {
      return new Promise((resolve, reject) => {
        window.ethereum
          .request({
            method: 'wallet_switchEthereumChain',
            params: [
              {
                chainId: '0x1b59',
              },
            ],
          })
          .then(resolve())
          .catch(reject);
      });
    },
    async addZetaChainTestnet() {
      // console.log('addZetaChainTestnet');
      if (!window.ethereum) {
        alert(this.$t('switchWallet'))
        return
      }
      let info = {
        chainName: 'ZetaChain Athens Testnet',
        chainId: '0x1b59',
        nativeCurrency: {
          name: 'ZETA',
          symbol: 'ZETA',
          decimals: 18,
        },
        rpcUrls: [
          'https://rpc.ankr.com/zetachain_evm_athens_testnet',
          'https://zetachain-athens-evm.blockpi.network/v1/rpc/public',
        ],
        blockExplorerUrls: ['https://explorer.zetachain.com/'],
      };
      if (this.isTp) {
        info.app_resource = {
          ic_chain_select:
            'https://hk.tpstatic.net/token/tokenpocket-1695111759609.png',
          ic_chain_unselect:
            'https://hk.tpstatic.net/token/tokenpocket-1695111789559.png',
          color_chain_bg: '0x005741',
          color_chain_text: '0xFFFFFF',
          ic_chain_unselect_dark:
            'https://hk.tpstatic.net/token/tokenpocket-1695181451439.png',
          ic_home_logo:
            'https://hk.tpstatic.net/token/tokenpocket-1695181482445.png',
        };
      }
      console.log('wallet-info', info);
      // try {
      //   await window.ethereum.request({
      //     method: 'wallet_addEthereumChain',
      //     params: [info],
      //   });
      // } catch (error) {
      //   console.log('add-err', error);
      // }
      return new Promise((resolve, reject) => {
        window.ethereum
          .request({
            method: 'wallet_addEthereumChain',
            params: [info],
          })
          .then(resolve)
          .catch(reject);
      });
    },
    checkChain(val) {
      // console.log('val', val);
      if (val === '0x1b59') {
        // this.step = 3;
        this.$store.commit('setStep', 3);
        this.getEthBalance().then((bal) => {
          this.balance = this.truncateDecimals(bal, 2);
        });
      }
    },
    getEthBalance() {
      return new Promise((resolve, reject) => {
        const web3 = new Web3(window.ethereum);
        web3.eth
          .getBalance(this.address)
          .then((balance) => {
            const etherString = web3.utils.fromWei(balance, 'ether');
            resolve(etherString);
          })
          .catch((error) => {
            console.log(error);
          });
      });
    },
    /** 保留小数位不四舍五入 */
    truncateDecimals(num, digits) {
      try {
        let numS = num.toString();
        let decPos = numS.indexOf('.');
        let substrLength = decPos == -1 ? numS.length : 1 + decPos + digits;
        let trimmedResult = numS.substr(0, substrLength);
        let finalResult = isNaN(trimmedResult) ? 0 : trimmedResult;
        return parseFloat(finalResult);
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.wallet-connect-content {
  display: flex;
  justify-content: space-between;
  margin: 0 0.45rem;
  .wallet-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-radius: 0.35rem;
    // box-shadow: 0 0.04rem 0.2rem 0 rgba(0, 0, 0, 0.1);
    padding: 0.09rem 0.1rem;
    border: 0.01rem solid #e3e3e3;
    background: #f5f5f5;
    cursor: pointer;
    pointer-events: none;
    &.active-item {
      pointer-events: auto;
      background: rgba(255, 255, 255, 0.71);
      .wallet-left {
        .wallet-logo {
          img {
            border: 0.02rem solid #fff;
          }
          .mask {
            opacity: 0;
          }
        }
        .wallet-info {
          color: #2a2a2a;
        }
      }
      .wallet-right {
        .enter {
          display: none;
        }
        .enter-on {
          display: block;
        }
      }
    }
    &.circle-item {
      background: none;
      border: none;
      box-shadow: none;
      .circle-list {
        display: flex;
        .circle {
          width: 0.04rem;
          height: 0.04rem;
          background: #e6e6e6;
          border-radius: 50%;
          &:nth-child(n + 2) {
            margin-left: 0.03rem;
          }
        }
      }
    }
    &.line-item {
      flex: 1;
      padding: 0;
      .circle-list {
        width: 100%;
        .circle {
          width: 100%;
          height: 0.02rem;
          border-radius: 0;
          &:nth-child(n + 2) {
            margin-left: 0;
          }
        }
      }
    }
    @media screen and (min-width: 1280px) {
      &:hover {
        background: #deebff;
        border: 0.01rem solid #2980fe;
      }
    }
    .wallet-left {
      display: flex;
      align-items: center;
      .wallet-logo {
        display: flex;
        align-items: center;
        position: relative;
        img {
          width: 0.48rem;
          height: 0.48rem;
          border-radius: 50%;
        }
        .mask {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          border-radius: 50%;
          opacity: 0.5;
          background: #ffffff;
        }
      }
      .wallet-info {
        margin-left: 0.12rem;
        font-size: 0.16rem;
        font-family: PingFang SC, PingFang SC-Semibold;
        color: #c9c9c9;
      }
    }
    .wallet-right {
      margin-left: 0.04rem;
      display: flex;
      align-items: center;
      img {
        width: 0.18rem;
        height: 0.18rem;
      }
      .enter {
        display: block;
      }
      .enter-on {
        display: none;
      }
    }
  }
}
@media screen and (max-width: 767px) {
  .wallet-connect-content {
    flex-wrap: wrap;
    margin: 0 0.32rem;
    .wallet-item {
      width: 100%;
      pointer-events: auto;
      padding: 0.16rem;
      border-radius: 0.46rem;
      &.circle-item {
        height: 0.7rem;
        .circle-list {
          display: flex;
          flex-direction: column;
          margin-left: 0.3rem;
          .circle {
            width: 0.05rem;
            height: 0.05rem;
            background: #e6e6e6;
            border-radius: 50%;
            &:nth-child(n + 2) {
              margin-left: 0;
              margin-top: 0.02rem;
            }
          }
        }
      }
      &.line-item {
        // flex: 1;
        // padding: 0;
        margin-left: 0.15rem;
        .circle-list {
          height: 0.7rem;
          width: 0.05rem;
          background: #2980fe;
          .circle {
            display: none;
            // background: #2980FE;
            // border-radius: 0;
            // &:nth-child(n + 2) {
            //   margin-top: 0;
            // }
          }
        }
      }
      .wallet-left {
        .wallet-logo {
          img {
            width: 0.56rem;
            height: 0.56rem;
          }
        }
        .wallet-info {
          font-size: 0.24rem;
        }
      }
      .wallet-right {
        img {
          width: 0.28rem;
          height: 0.28rem;
        }
      }
      // &:hover {
      //   border: 0.01rem solid #e3e3e3;
      //   background: #f5f5f5;
      // }
    }
  }
}
</style>
